<template>
  <div class="item-list">
    <div class="name-icon" @click="userCenter(dataList.id)">
      <img class="icon" :src="dataList.icon ? dataList.icon : '/static/img/mr-usericon.png'" alt="" />
      <div class="name">{{dataList.userName}}</div>
      <img v-if="dataList.certify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt="">
    </div>
    <el-button
    v-if="dataList.attentionFlag == 0"
      type="danger"
      plain
      round
      size="mini"
      class="el-icon-plus follow-btn-on follow-btn"
      @click="followBtn(dataList.id)"
    >
      关注</el-button
    >
    <el-tooltip v-if="dataList.attentionFlag == 1" content="取消关注" placement="bottom" effect="light">
      <el-button
      type="danger"
      plain
      round
      size="mini"
      class="follow-btn"
      @click="followBtn(dataList.id)"
    >
      已关注</el-button
    >
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "hotPost",
  props: ["dataList"],
  data() {
    return {};
  },
  methods: {
    followBtn(id) {
      this.$api
        .attentionHandle({
          userId: id,
        })
        .then((res) => {
          this.dataList.attentionFlag = this.dataList.attentionFlag == 1 ? 0 : 1;
          this.$message.success(res.data.msg);
        });
    },
    userCenter(id) {
      this.$router.push("/usercenter/" + id);
    },
  },
};
</script>

<style scoped lang="scss">
.item-list {
  width: 100%;
  padding: 20px 24px;
  border-bottom: 1px solid #f7f7f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:last-child {
    border-bottom: none;
  }
  .name-icon {
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }
    .name {
      margin-left: 15px;
      font-size: 16px;
      font-weight: 600;
      color: #121212;
    }
    .dv-rz {
      width: 14px;
      height: 14px;
      margin-left: 5px;
    }
  }
  .follow-btn {
    padding: 6px 17px;
    background: #efefef;
    border-radius: 4px;
    color: #121212;
    font-size: 16px;
    border: none;
  }
  .follow-btn-on {
    background: #E5EFFE;
    color: #317DFF;
  }
 
}
</style>


// WEBPACK FOOTER //
// src/components/FansFollowList.vue